/* eslint-disable import/no-anonymous-default-export */
class Stations {
  stations: any;
  constructor(stations: any) {
    this.stations = stations
  }

  toArray() {
    const stations: any = []

    for (const name in this.stations) {
      // eslint-disable-next-line no-prototype-builtins
      if (this.stations.hasOwnProperty(name)) {
        const station = this.stations[name]
        station.name = name
        stations.push(station)
      }
    }

    return stations
  }

  interchanges() {
    const interchangeStations = this.toArray()

    return interchangeStations.filter(function (station: any) {
      return station.marker[0].marker === 'interchange'
    })
  }

  transferStations() {
    const transferStations = this.toArray()

    return transferStations.filter(function (station: any) {
      return station.marker[0].marker === 'transfer'
    })
  }

  normalStations() {
    const stations = this.toArray()

    return stations.filter(function (station: any) {
      return station.marker[0].marker === 'normal'
    })
  }
}

export default function (stations: any) {
  return new Stations(stations)
}
